<template>
  <article
    v-if="id && postData && isLocked"
    class="block-single-post block-single-video"
  >
    <!-- Locked videos: try remembered passwords first (opens the lightbox),
         otherwise go to the single page's password form -->
    <button
      type="button"
      class="post-block-link"
      :title="postData.title.rendered.decodeHtmlEntities()"
      @click="openLocked"
    >
      <span class="video-thumb">
        <wpImage
          v-if="postData.featured_image_src"
          :data="postData.featured_image_src"
          size="large"
          class="post-block-image"
          lazy
          background
          placeholder
        />
        <span v-else class="post-block-image"></span>
        <span class="play-badge" v-html="playIcon"></span>
      </span>
      <div class="content-block">
        <ModuleHeading :level="3">{{ postData.title.rendered.decodeHtmlEntities() }}</ModuleHeading>
        <Categories
          v-if="postData.acf && postData.acf._categories"
          :categories="postData.acf._categories"
          taxonomy="inspir_taxonomy"
          :link="false"
          :title="false"
        />
      </div>
    </button>
  </article>
  <article
    v-else-if="id && postData"
    class="block-single-post block-single-video"
  >
    <button
      type="button"
      class="post-block-link"
      :title="postData.title.rendered.decodeHtmlEntities()"
      @click="openLightbox"
    >
      <span class="video-thumb">
        <wpImage
          v-if="postData.featured_image_src"
          :data="postData.featured_image_src"
          size="large"
          class="post-block-image"
          lazy
          background
          placeholder
        />
        <span v-else class="post-block-image"></span>
        <span class="play-badge" v-html="playIcon"></span>
      </span>
      <div class="content-block">
        <ModuleHeading :level="3">{{ postData.title.rendered.decodeHtmlEntities() }}</ModuleHeading>
        <Categories
          v-if="postData.acf && postData.acf._categories"
          :categories="postData.acf._categories"
          taxonomy="inspir_taxonomy"
          :link="false"
          :title="false"
        />
      </div>
    </button>
  </article>
  <div v-else class="block-single-post dummy">
    <div class="post-block-image"></div>
    <div class="dummy-text">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="dummy-tags ">
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
import WpImage from "@/components/elements/WpImage";
import Categories from "@/components/blocks/CategoriesBlock";

import { mapGetters } from "vuex";

export default {
  name: "block-single-video",
  props: ["id", "list"],
  components: {
    WpImage,
    Categories
  },
  data() {
    return {
      unlocking: false,
      playIcon:
        '<svg width="48" height="48" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle cx="33" cy="33" r="33" fill="#FFF" opacity="0.9"/><path d="M27 21.5 47 33 27 44.5z" fill="#2A2E34"/></g></svg>'
    };
  },
  computed: {
    ...mapGetters(["getPageById"]),
    postData() {
      let post = null;
      if (this.id) {
        post = this.getPageById(this.id);
      }
      return post;
    },
    isLocked() {
      return (
        this.postData &&
        this.postData.protection &&
        this.postData.protection.locked === true
      );
    }
  },
  methods: {
    openLightbox() {
      this.$store.commit("SET_ACTIVE_VIDEO", this.id);
    },
    openLocked() {
      if (this.unlocking) return;
      this.unlocking = true;
      this.$store
        .dispatch("tryStoredPasswords", {
          id: this.id,
          type: this.postData.type
        })
        .then(success => {
          this.unlocking = false;
          if (success) {
            this.openLightbox();
          } else {
            this.$router.push(
              this.postData.link.replace(window.WPVUE.home_url, "")
            );
          }
        });
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";
.block-single-video {
  button.post-block-link {
    appearance: none;
    -webkit-appearance: none;
    border: 0;
    width: 100%;
    font: inherit;
    color: inherit;
    text-align: left;
    cursor: pointer;
  }
  .video-thumb {
    display: block;
    position: relative;
    margin: 0 -20px 20px;
    .post-block-image {
      display: block;
      margin: 0;
      padding-bottom: 60%;
    }
    .play-badge {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 30; // WpImage's internal layers go up to 20
      transition: transform 0.12s ease-in-out;
      svg {
        display: block;
        width: 48px;
        height: 48px;
      }
    }
  }
  .post-block-link:hover .play-badge {
    transform: translate(-50%, -50%) scale(1.08);
  }
}
</style>
